// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Kvoa","overflowing":"ReadFullNote_overflowing__1uJ87"};